import { Box, Typography } from "@mui/material";
import { Info } from "@mui/icons-material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";

const wrapperStyles = {
  p: 2,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  flex: 1,
  gap: "12px",
  background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
  border: "1px solid #e2e8f0",
  borderRadius: "12px",
  boxShadow:
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    border: "1px solid #3b82f6",
  },
};

const iconBoxStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 48,
  minHeight: 48,
  borderRadius: "50%",
  background: "linear-gradient(135deg, #eef2ff 0%, #c7d2fe 100%)",
  border: "2px solid #6366f1",
  boxShadow: "0 2px 4px rgba(99, 102, 241, 0.2)",
};

const contentStyles = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  textAlign: "left",
};

const titleStyles = {
  font: "var(--semibold-sm)",
  color: "#6366f1",
  fontWeight: 600,
};

const DefaultNotification = ({ notification }: { notification: NotificationFullData }) => (
  <Box sx={wrapperStyles}>
    <Box sx={iconBoxStyles}>
      <Info sx={{ color: "#6366f1", fontSize: 24 }} />
    </Box>
    <Box sx={contentStyles}>
      <Typography sx={titleStyles}>Notification</Typography>
      <Typography sx={{ color: "#64748b", font: "var(--body-xs)", fontWeight: 400 }}>
        {notification.message}
      </Typography>
    </Box>
  </Box>
);

export default DefaultNotification; 
